/* eslint-env browser */
"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOMException = require("domexception");

var _require = require("whatwg-url"),
    parseURL = _require.parseURL,
    serializeURL = _require.serializeURL,
    serializeURLOrigin = _require.serializeURLOrigin;

var _require2 = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require2.setupForSimpleEventAccessors;

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var idlUtils = require("../generated/utils");

var Blob = require("../generated/Blob");

var CloseEvent = require("../generated/CloseEvent");

var Event = require("../generated/Event");

var MessageEvent = require("../generated/MessageEvent");

var productions = {
  // https://tools.ietf.org/html/rfc7230#section-3.2.6
  token: /^[!#$%&'*+\-.^_`|~\dA-Za-z]+$/
}; // https://tools.ietf.org/html/rfc6455#section-4.3
// See Sec-WebSocket-Protocol-Client, which is for the syntax of an entire header value. This function checks if a
// single header conforms to the rules.

function verifySecWebSocketProtocol(str) {
  return productions.token.test(str);
}

var openSockets = new WeakMap();

var WebSocketImpl = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(WebSocketImpl, _EventTargetImpl);

  var _super = _createSuper(WebSocketImpl);

  function WebSocketImpl(constructorArgs, privateData) {
    var _this;

    _classCallCheck(this, WebSocketImpl);

    _this = _super.call(this, [], privateData);
    var window = privateData.window;
    _this._ownerDocument = idlUtils.implForWrapper(window._document);
    var url = constructorArgs[0];
    var protocols = constructorArgs[1] !== undefined ? constructorArgs[1] : [];
    var urlRecord = parseURL(url);

    if (urlRecord === null) {
      throw new DOMException("The URL '".concat(url, "' is invalid."), "SyntaxError");
    }

    if (urlRecord.scheme !== "ws" && urlRecord.scheme !== "wss") {
      throw new DOMException("The URL's scheme must be either 'ws' or 'wss'. '".concat(urlRecord.scheme, "' is not allowed."), "SyntaxError");
    }

    if (urlRecord.fragment !== null) {
      throw new DOMException("The URL contains a fragment identifier ('".concat(urlRecord.fragment, "'). Fragment identifiers ") + "are not allowed in WebSocket URLs.", "SyntaxError");
    }

    if (typeof protocols === "string") {
      protocols = [protocols];
    }

    var protocolSet = new Set();

    var _iterator = _createForOfIteratorHelper(protocols),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var protocol = _step.value;

        if (!verifySecWebSocketProtocol(protocol)) {
          throw new DOMException("The subprotocol '".concat(protocol, "' is invalid."), "SyntaxError");
        }

        var lowered = protocol.toLowerCase();

        if (protocolSet.has(lowered)) {
          throw new DOMException("The subprotocol '".concat(protocol, "' is duplicated."), "SyntaxError");
        }

        protocolSet.add(lowered);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _this._urlRecord = urlRecord;
    _this.url = serializeURL(urlRecord);
    _this._ws = new WebSocket(_this.url, protocols);

    _this._ws.onopen = function () {
      _this._dispatch(Event.createImpl(["open"], {
        isTrusted: true
      }));
    };

    _this._ws.onerror = function () {
      _this._dispatch(Event.createImpl(["error"], {
        isTrusted: true
      }));
    };

    _this._ws.onclose = function (event) {
      _this._dispatch(CloseEvent.createImpl(["close", {
        wasClean: event.wasClean,
        code: event.code,
        reason: event.reason
      }], {
        isTrusted: true
      }));
    };

    _this._ws.onmessage = function (event) {
      _this._dispatch(MessageEvent.createImpl(["message", {
        data: event.data,
        origin: serializeURLOrigin(_this._urlRecord)
      }], {
        isTrusted: true
      }));
    };

    var openSocketsForWindow = openSockets.get(window._globalProxy);

    if (openSocketsForWindow === undefined) {
      openSocketsForWindow = new Set();
      openSockets.set(window._globalProxy, openSocketsForWindow);
    }

    openSocketsForWindow.add(_assertThisInitialized(_this));
    return _this;
  } // https://html.spec.whatwg.org/multipage/web-sockets.html#make-disappear


  _createClass(WebSocketImpl, [{
    key: "_makeDisappear",
    value: function _makeDisappear() {
      this._eventListeners = Object.create(null);

      this._ws.close(1001);
    }
  }, {
    key: "close",
    value: function close() {
      var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (code !== undefined && code !== 1000 && !(code >= 3000 && code <= 4999)) {
        throw new DOMException("The code must be either 1000, or between 3000 and 4999. ".concat(code, " is neither."), "InvalidAccessError");
      }

      if (reason !== undefined && Buffer.byteLength(reason, "utf8") > 123) {
        throw new DOMException("The message must not be greater than 123 bytes.", "SyntaxError");
      }

      return this._ws.close(code, reason);
    }
  }, {
    key: "send",
    value: function send(data) {
      if (Blob.isImpl(data)) {
        data = data._buffer;
      }

      this._ws.send(data);
    }
  }, {
    key: "readyState",
    get: function get() {
      return this._ws.readyState;
    }
  }, {
    key: "bufferedAmount",
    get: function get() {
      return this._ws.bufferedAmount;
    }
  }, {
    key: "extensions",
    get: function get() {
      return this._ws.extensions;
    }
  }, {
    key: "protocol",
    get: function get() {
      return this._ws.protocol;
    }
  }, {
    key: "binaryType",
    get: function get() {
      return this._ws.binaryType;
    },
    set: function set(val) {
      this._ws.binaryType = val;
    }
  }], [{
    key: "cleanUpWindow",
    value: function cleanUpWindow(window) {
      var openSocketsForWindow = openSockets.get(window._globalProxy);

      if (openSocketsForWindow !== undefined) {
        var _iterator2 = _createForOfIteratorHelper(openSocketsForWindow),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ws = _step2.value;

            ws._makeDisappear();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);

  return WebSocketImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(WebSocketImpl.prototype, ["open", "message", "error", "close"]);
exports.implementation = WebSocketImpl;